import consumer from "./consumer"

document.addEventListener("turbolinks:load", function() {
  var messages = document.getElementById('messages');
  if (messages !== null) {
    consumer.subscriptions.create({channel: "ChatRoomsChannel", chat_room_id: messages.dataset.chatRoomId}, {
      connected() {
        console.log(`Подключено к каналу чата`)
        $('#messages').parent().scrollTop($('#messages').height())
      },

      disconnected() {
        console.log(`Отключен канал чата`)
      },

      received(data) {
        $('#messages').append(data['message']);
        $('#messages').parent().scrollTop($('#messages').height())
      }
    });
  }
})
